import { _js } from '@ifixit/utils/localize';
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const InsertImageButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.commands.activateMediaManager()}
         icon={<FontAwesomeIcon icon={faImage} />}
         title={_js('Insert an image')}
      />
   );
};
